import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon, object = authed
    const [checked, setChecked] = useState(false);

    const refresh = useCallback(async () => {
        const token = localStorage.getItem("ssc_token");
        if (!token) {
            setUser(false);
            setChecked(true);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch (e) {
            localStorage.removeItem("ssc_token");
            setUser(false);
        } finally {
            setChecked(true);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = (token, userObj) => {
        localStorage.setItem("ssc_token", token);
        try { sessionStorage.removeItem("ssc_verify_reminded"); } catch (e) {}
        setUser(userObj);
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {}
        localStorage.removeItem("ssc_token");
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, logout, refresh, checked }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
